import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { usePostHog } from "@posthog/react";
import { logOut } from "components/navigation/menu-bar";
import {
  switchedOrganisationCookieName,
  useIdentity,
} from "contexts/identity-context";
import GeoscapeDeveloperSvg from "icons/hub-logo-signIn.svg?react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router";
import { useIntercom } from "react-use-intercom";
import useDarkMode from "use-dark-mode";

export const NoAccessToOrganisations = () => {
  const { value: isDark } = useDarkMode();
  const [identityState, setUserState] = useIdentity();

  const [_c, setCookie, removeCookie] = useCookies([
    switchedOrganisationCookieName,
  ]);
  const { update, shutdown } = useIntercom();
  const posthog = usePostHog();

  return (
    <div className="w-full h-screen relative">
      <div className="flex flex-col items-center h-full pt-16 bg-background overflow-auto">
        <div className="flex justify-center">
          {useLocation().pathname !== "/sign-up" && (
            <GeoscapeDeveloperSvg
              fill={isDark ? "white" : "black"}
              style={{ width: "450px", height: "100px", padding: "0px" }}
            />
          )}
        </div>
        <div className="h-8" />
        <div className="w-[410px]">
          <Card>
            <CardHeader>
              <CardTitle>
                It Looks Like Your Organisation's Plan Has Changed
              </CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
              <p className="text-sm">
                Your access to Hub is currently unavailable because your
                organisation's subscription no longer supports multiple team
                members.
              </p>
              <p className="text-sm">
                Please contact your organisation's Owner. They have the ability
                to upgrade to a plan that includes team access, which will
                restore your account immediately.
              </p>
            </CardContent>
            <CardFooter className="justify-center">
              <Button
                className="w-full"
                onClick={() =>
                  logOut(setUserState, removeCookie, shutdown, posthog)
                }
              >
                Sign Out
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </div>
  );
};
